import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      t="1637645346060"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="1667"
      width="32"
      height="32"
    >
      <path
        d="M895.239939 778.964214 512.17652 395.899772 124.080481 783.996834l-0.033769-0.070608c-13.137205 12.709463-31.024597 20.530592-50.731428 20.530592-40.376593 0-73.111135-32.736589-73.111135-73.115228 0-19.705807 7.819083-37.591153 20.528546-50.730405l-0.035816-0.034792 438.681134-438.686251 0.034792 0.035816c13.281491-13.779841 31.915897-22.3838 52.586682-22.3838 0.071631 0 0.106424 0 0.178055 0 0.072655 0 0.10847 0 0.144286 0 20.669762 0 39.341007 8.603959 52.623521 22.3838l0.033769-0.035816 438.684204 438.683181-0.179079 0.180102c12.565177 13.140275 20.313651 30.950919 20.313651 50.588165 0 40.378639-32.736589 73.115228-73.114205 73.115228C928.513764 804.453748 908.664693 794.565541 895.239939 778.964214z"
        p-id="1668"
      ></path>
    </svg>
  )
}

const UpArrowIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon></Icon>
    </MorphReplace>
  )
}

// 默认参数
UpArrowIcon.defaultProps = {
  width: 10,
  height: 10,
  fill: '#bfbfbf',
}
// 参数类型
UpArrowIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default UpArrowIcon
